import Burning from '@/models/Burning'
import User, { hasRole, Role } from '@/models/User'

export default class BurningPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, burning: Burning) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === burning.entry.catalog.company.id
			case Role.AUDITOR:
				return burning.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, burning: Burning) {
		return hasRole(user, Role.USER) && user.company?.id === burning.entry.catalog.company.id
	}

	restore(user: User, burning: Burning) {
		return hasRole(user, Role.USER) && user.company?.id === burning.entry.catalog.company.id
	}

	delete(user: User, burning: Burning) {
		return hasRole(user, Role.USER) && user.company?.id === burning.entry.catalog.company.id
	}

	forceDelete(_user: User, _burning: Burning) {
		return false
	}
}
